<template>
    <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74"><defs></defs><path fill="#AEAEB3" d="M57.73,38.22a1,1,0,0,0-1.07,1.07,19.66,19.66,0,0,1-39.32,0,1.07,1.07,0,1,0-2.14,0A21.77,21.77,0,0,0,34.59,61l1.34.15v9.7H25.09a1.07,1.07,0,0,0,0,2.14H48.91a1.07,1.07,0,0,0,0-2.14H38.07v-9.7L39.41,61A21.77,21.77,0,0,0,58.8,39.29,1,1,0,0,0,57.73,38.22Z"/><path fill="#AEAEB3" d="M37,54.75A15.65,15.65,0,0,1,21.54,39.2V16a15.46,15.46,0,0,1,30.92,0v23.3A15.48,15.48,0,0,1,37,54.75ZM37,2.83A13.18,13.18,0,0,0,23.84,16V39.2A13.33,13.33,0,0,0,37,52.45,13.18,13.18,0,0,0,50.16,39.29V16A13.18,13.18,0,0,0,37,2.83Z"/></svg>
</template>

<script>
export default {};
</script>
